<template>
  <div class="connect-wallet-modal">
    <select-wallet
      :initData="initData"
      @setWallet="setWallet"
      v-if="!walletSelected"
    />
    <get-address
      v-if="walletSelected && !addressSelected && !errorConnecting"
      :wallet="walletSelected"
      :project="projectSelected"
      @onAddressSelected="onAddressSelected"
      @onError="onError"
      @onCancelled="close"
    />
    <div v-if="addressSelected && !errorConnecting && !errorCreating">
      <div class="d-flex flex-column align-center">
        <div class="heading-4 font-weight-medium text-center">
          Connecting your wallet
        </div>
        <div class="mt-5 darkgray--text text-4">Please be patient.</div>
        <v-progress-circular
          indeterminate
          :size="80"
          :width="6"
          color="primary"
          class="mt-10"
        ></v-progress-circular>
      </div>
    </div>
    <div v-if="errorConnecting || errorCreating">
      <div class="text-4 text-center error--text py-10">
        <div v-if="errorConnecting">Error: {{ errorConnecting.message }}</div>
        <div v-if="errorCreating && addressSelected">
          Error: {{ errorCreating.message }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectWallet from "./SelectWallet";
import GetAddress from "./GetAddress";
import { mapGetters } from "vuex";
export default {
  components: {
    SelectWallet,
    GetAddress,
  },
  props: ["initData"],
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/isAuthenticated",
      walletCreation: "userWallets/walletCreation",
      project: "projectConfig/latestProject",
      walletList: "userWallets/walletList",
    }),
    errorCreating() {
      return this.walletCreation?.error;
    },
  },
  data: () => ({
    walletSelected: null,
    projectSelected: null,
    addressSelected: null,
    errorConnecting: null,
  }),
  methods: {
    setWallet(wallet, project) {
      this.projectSelected = project;
      this.walletSelected = wallet;
    },
    async onAddressSelected(address, metadata) {
      this.addressSelected = address;
      if (!this.isAuthenticated) {
        await this.$store.dispatch("auth/guestLogin");
      }
      await this.$store.dispatch("userWallets/addWallet", {
        accountLabel: this.walletSelected.text + " " + address.slice(-4),
        accountType: this.walletSelected.type || this.walletSelected.name,
        address,
        network: this.projectSelected.config.network,
        metadata,
      });
      if (!this.errorCreating) {
        this.$store.dispatch("addAlert", {
          type: "success",
          title: "Success",
          message: "Your wallet has successfully connected.",
        });
        if (
          this.project?.config?.network === this.projectSelected.config.network
        ) {
          const newWallet = this.walletList.result.find(
            (w) => w.address.toLowerCase() === address.toLowerCase()
          );
          this.$store.dispatch("userWallets/setCurrentWallet", newWallet);
        }
        this.close();
      }
    },
    close() {
      this.$store.dispatch("closeAuthModal");
    },
    onError(error) {
      this.errorConnecting = error;
    },
  },
};
</script>